<!-- eslint-disable vue/no-mutating-props -->
<!-- eslint-disable vue/no-mutating-props -->
<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="boxs">
    <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
      <el-col
        :span="6"
        class="bottom"
        v-for="(item, index) in select"
        :key="index"
      >
        <el-input
          v-model="selectList[item.prop]"
          :placeholder="item.placeholder"
          clearable
          v-if="item.type === 'input1' ? true : false"
          @blur="selectChenge"
          size="small"
        >
        </el-input>
        <el-input
          v-model="selectList[item.prop]"
          :placeholder="item.placeholder"
          clearable
          v-if="item.type === 'input' ? true : false"
          @blur="selectChenge"
          size="small"
          :maxlength="item.maxLenth"
        >
        </el-input>
        <el-input
          v-model="selectList[item.prop]"
          :placeholder="item.placeholder"
          clearable
          v-if="item.type === 'input2' ? true : false"
          @blur="selectChenge"
          size="small"
          :maxlength="item.maxLenth"
          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
        ></el-input>
        <el-select
          size="small"
          clearable
          v-if="item.type === 'select' ? true : false"
          v-model="selectList[item.prop]"
          :placeholder="item.placeholder"
          @change="selectChange1(...arguments, item)"
          :disabled="item.List.length === 0 && !item.allowCreate"
          :multiple="item.multiple"
          :collapse-tags="item.multiple"
          @clear="clear(item)"
          :allow-create="item.allowCreate"
          :filterable="item.filterable"
          :default-first-option="item.defaultFirstOption"
        >
          <el-option
            v-if="![4000, 4003].includes(item.cfgID) && !item?.multiple"
            label="全部"
            value="全部"
            @click.native="selectAll(item)"
          ></el-option>
          <el-option
            v-for="ele in item.List"
            :key="ele.value"
            :label="ele.label"
            :value="ele.value"
          >
          </el-option>
        </el-select>

        <el-cascader
          size="small"
          v-if="item.type == 'selectIndex'"
          :placeholder="item.placeholder"
          v-model="selectList[item.prop]"
          :value="selectList[item.prop]"
          :options="item.List"
          :props="indexProps"
          @change="changeDepartment"
          :show-all-levels="false"
          clearable
          collapse-tags
          @visible-change="visibleChange"
        ></el-cascader>
        <el-date-picker
          size="small"
          v-if="item.type === 'picker' ? true : false"
          v-model="selectList[item.prop]"
          type="datetimerange"
          range-separator="至"
          :start-placeholder="getPlaceholdText(item.placeholder, 0)"
          :end-placeholder="getPlaceholdText(item.placeholder, 1)"
          @blur="selectChenge"
          :default-time="['00:00:00', '23:59:59']"
          clearable
        >
        </el-date-picker>

        <el-date-picker
          size="small"
          v-if="item.type === 'datetime' ? true : false"
          v-model="selectList[item.prop]"
          type="datetime"
          :placeholder="item.placeholder"
        >
        </el-date-picker>
        <!-- 远程模糊搜索 -->
        <el-select
          v-if="item.type === 'selectBus' ? true : false"
          v-model="selectList[item.prop]"
          filterable
          :placeholder="item.placeholder"
          size="small"
          remote
          :remote-method="write_remoteMethod"
          :loading="write_doctor_loading"
          @change="writeChange"
          clearable
        >
          <el-option
            v-for="(item, index) in item.List"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-if="item.type === 'editorialDoctor' ? true : false"
          v-model="selectList[item.prop]"
          filterable
          :placeholder="item.placeholder"
          size="small"
          remote
          :remote-method="editorial_remoteMethod"
          :loading="write_doctor_loading"
          @change="writeChange"
          clearable
        >
          <el-option
            v-for="(item, index) in item.List"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <!--疾病搜索-->
        <el-select
          v-if="item.type === 'disease' ? true : false"
          v-model="selectList[item.prop]"
          filterable
          :placeholder="item.placeholder"
          size="small"
          remote
          :remote-method="disease_remoteMethod"
          :loading="disease_loading"
          @change="writeChange"
          clearable
        >
          <el-option
            v-for="(item, index) in item.List"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <!-- 搜索回答人 是不是jd健康体系的医生 -->
        <el-select
          size="small"
          v-if="item.type === 'originSearch' ? true : false"
          v-model="selectList[item.prop]"
          filterable
          remote
          :placeholder="item.placeholder"
          :remote-method="doctor_remoteMethod"
          :loading="loading"
          clearable
        >
          <el-option
            v-for="(val, index) in item.List"
            :key="index"
            :label="val.label"
            :value="val.value"
          >
          </el-option>
        </el-select>

        <el-select
          size="small"
          v-if="item.type === 'originSearch_jbbk' ? true : false"
          v-model="selectList[item.prop]"
          filterable
          remote
          multiple
          reserve-keyword
          :placeholder="item.placeholder"
          :remote-method="doctor_remoteMethod"
          :loading="loading"
          multiple-limit="1"
          clearable
        >
          <el-option
            v-for="(item, index) in item.List"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <!-- 级联选择 -->

        <el-cascader
          size="small"
          v-if="item.type === 'cascader' ? true : false"
          :placeholder="item.placeholder"
          v-model="selectList[item.prop]"
          :value="selectList[item.prop]"
          :options="departmentList"
          :props="departmentProps"
          :show-all-levels="false"
          @change="changeDepartment"
          @visible-change="visibleChange"
          clearable
        ></el-cascader>

        <el-cascader
          size="small"
          v-if="item.type == 'selectCascader'"
          :placeholder="item.placeholder"
          v-model="selectList[item.prop]"
          :value="selectList[item.prop]"
          :options="item.List"
          :props="distributeProps"
          @change="changeDepartment"
          :show-all-levels="false"
          clearable
          @visible-change="visibleChange"
        ></el-cascader>

        <rangeSelection
          :item="item"
          v-if="item.type === 'rangeSelect'"
          :selectList="selectList"
        >
        </rangeSelection>
        <rangeSelection
          :item="item"
          v-if="item.type === 'rangeSelect1'"
          :selectList="selectList"
        >
        </rangeSelection>
      </el-col>
      <el-col :span="6" style="flex: 1; text-align: right">
        <div class="bottom">
          <el-button
            class="but"
            @click="getSearchVal"
            v-if="isBtn === 1"
            type="primary"
          >
            查询</el-button
          >
          <el-button class="but" @click="empty"> 重置</el-button>
          <searchFilter
            class="searchFilter"
            :searchFilterList="searchFilterList"
            :checkList="checkList"
            @click="searchFilter"
            @checkBoxedChange="checkBoxedChange"
            @clickSingleBoxed="clickSingleBoxed"
            @popHide="popHide"
            v-if="isShowFilter === 1"
            >搜索筛选</searchFilter
          >
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import searchFilter from "./searchFilter.vue";
import rangeSelection from "./rangeSelection.vue";
import {
  listDiseaseInfoByName,
  queryDepartments,
  searchDiseaseInfoByParam,
  pageCategoriesByBusinessId,
  pageChannelsByCategoryId,
} from "@/api/man";
// import {queryDoctorName} from "@/api/questionsLibrary"
import {
  pageCategoriesByBusinessIds,
  pageChannelsByCategoryIds,
  queryChildAttributeByPid,
} from "@/api/contentDistribution";
import { manListContentIndexTree } from "@/api/indexs";

export default {
  props: {
    select: {
      default: () => {
        return {};
      },
      type: Object,
    },
    selectList: {
      default: () => {
        return [];
      },
      type: Array,
    },
    num: {
      default: () => {
        return;
      },
      type: Number,
    },
    isBtn: {
      default: () => {
        return;
      },
      type: Number,
    },
    searchFilterList: {
      default: () => {
        return;
      },
      type: Array,
    },
    checkList: {
      default: () => {
        return;
      },
      type: Array,
    },
    isShowFilter: {
      default: () => {
        return;
      },
      type: Number,
    },
    sortOrderParams: {
      default: () => {
        return;
      },
      type: Array,
    },
  },
  data() {
    return {
      options: [],
      businessIds: [],
      selectedDeparttId: null,
      questionState: null,
      departmentList: [],
      distributeList: [],
      departmentProps: {
        multiple: true,
        value: "departId",
        label: "departName",
        children: "departmentDTOList",
        checkStrictly: true,
      },
      distributeProps: {
        multiple: true,
        value: "id",
        label: "name",
        children: "contentLabels",
        checkStrictly: true,
      },
      indexProps: {
        //索引下拉框配置
        multiple: true,
        value: "indexId",
        label: "name",
        children: "contentIndexes",
        checkStrictly: true,
      },
      diseaseInfoOptions: [],
      doctorInfoOptions: [], // 回答人（医生信息）查询列表
      selectDiseaseInfoId: "",
      publishStatus: null, // 公开状态
      pageConfig: {
        pageNo: 1,
        pageSize: 200,
      },
    };
  },
  created() {
    this.queryDepartments();
    this.initData();
  },
  methods: {
    initData() {
      this.select.forEach((item) => {
        if (item.type === "selectIndex") {
          this.getIndexTreeList();
        }
      });
    },
    visibleChange(val) {
      if (val) {
        //此处可以出来选中下拉选项，清空input搜索值
      }
      this.$nextTick(() => {
        // 添加这段代码
        const $el = document.querySelectorAll(
          ".el-cascader-panel .el-cascader-node[aria-owns]"
        );
        Array.from($el).map((item) => item.removeAttribute("aria-owns"));
      });
    },
    write_remoteMethod(val) {
      this.$emit("write_remoteMethod", val);
    },
    editorial_remoteMethod(val) {
      this.$emit("editorial_remoteMethod", val);
    },
    // 点击
    clickSingleBoxed(checked, item) {
      console.log("clickSingleBoxed======>111111", checked, item);
      this.$emit("clickSingleBoxed", checked, item);
    },
    empty() {
      this.$emit("empty", this.selectList);
    },
    searchFilter() {
      this.$emit("searchFilter");
    },
    // 获取日期中占位文字
    getPlaceholdText(str, index) {
      if (str.search("/") != -1) {
        const arr = str.split("/");
        return arr[index];
      } else {
        return index == 0 ? "开始日期" : "结束日期";
      }
    },
    // 搜索筛选点击
    checkBoxedChange(value) {
      this.$emit("checkBoxedChange", value);
    },
    // 搜索筛选隐藏
    popHide(value) {
      this.$emit("popHide", value);
    },
    // 疾病搜索的方法
    disease_remoteMethod(val) {
      this.$emit("disease_remoteMethod", val);
    },
    // 回答人（医生搜索的方法）
    doctor_remoteMethod(val) {
      this.$emit("doctor_remoteMethod", val);
    },
    recursionObj(node, callback, judge) {
      if (judge(node)) {
        node = callback(node);
      }
      if (!node.contentIndexes || node.contentIndexes.length === 0) {
        return;
      }
      for (let i = 0; i < node.contentIndexes.length; i++) {
        if (judge(node)) {
          this.recursionObj(node.contentIndexes[i], callback, () => true);
        } else {
          this.recursionObj(node.contentIndexes[i], callback, judge);
        }
      }
      return;
    },
    // 获取索引下拉数据
    getIndexTreeList() {
      manListContentIndexTree().then((res) => {
        // 处理树的叶子结点
        for (let i = 0; i < res.length; i++) {
          this.recursionObj(
            res[i],
            (curNode) => {
              curNode.contentIndexes = undefined;
              return curNode;
            },
            (node) => node.contentIndexes.length === 0
          );
        }
        const index = this.select.findIndex(
          (item) => item.type === "selectIndex"
        );
        this.select[index].List = res;
      });
    },
    //获取科室信息
    queryDepartments() {
      queryDepartments({
        tenantId: this.$commonJs.getTenantId(),
      })
        .then((res) => {
          console.log("resres", res);
          this.departmentList = res || [];
        })
        .catch((err) => {
          this.departmentList = [];
        });
    },
    //通过关键词获取疾病
    searchDiseaseInfoByParam(query) {
      // console.log(query)
      // searchDiseaseInfoByParam({
      //   contentName: query
      // }).then(res => {
      //   if (res && res.data) {
      //     this.diseaseInfoOptions = res.data || []
      //     this.loading = false
      //   }
      // }).catch(err => {
      //   this.diseaseInfoOptions = []
      //   this.loading = false
      // })
    },
    selectChenge(newValue, old) {
      // console.log('selectChenge=======>',newValue, old, this.selectList);
      var timetamp = Number(this.selectList.contributeTime);

      let data = {
        form: this.selectList,
        time: timetamp,
      };
      if (this.selectList.business == newValue) {
        this.pageCategoriesByBusinessId(this.selectList.business);
      }
      if (this.selectList.categoryId == newValue) {
        this.pageChannelsByCategoryId(this.selectList.categoryId);
      }
      if (this.selectList.nature == newValue) {
        this.queryChildAttributeByPid(this.selectList.nature);
      }
      this.$emit("selectChenge", old);
    },
    selectChange1(newValue, old, item) {
      console.log("selectChenge11111=======>", newValue, old, item);
      var timetamp = Number(this.selectList.contributeTime);

      let data = {
        form: this.selectList,
        time: timetamp,
      };
      if (this.selectList.business == newValue) {
        this.pageCategoriesByBusinessId(this.selectList.business);
      }
      if (this.selectList.categoryId == newValue) {
        this.pageChannelsByCategoryId(this.selectList.categoryId);
      }
      if (this.selectList.nature == newValue) {
        this.queryChildAttributeByPid(this.selectList.nature);
      }
      if ("questionSource" == item.prop) {
        console.log("questionSource3333333");
        if (
          !newValue.includes("全部") &&
          !old.includes("全部") &&
          newValue.length === item.List.length
        ) {
          this.selectList[item.prop].unshift("全部");
        } else if (
          newValue.includes("全部") &&
          newValue.length - 1 < item.List.length
        ) {
          this.selectList[item.prop] = this.selectList[item.prop].filter(
            (subItem) => {
              return subItem !== "全部";
            }
          );
        }
      }
      this.$emit("selectChenge", old);
    },
    // 清除select tag 初始数据
    clear(item) {
      console.log("232", item);
      this.selectList[item.prop] = null;
      console.log("this.selectList[item.prop]", this.selectList[item.prop]);
    },
    // 全部
    selectAll(item) {
      console.log(
        "点击了全部======>",
        this.selectList[item.prop],
        item.prop,
        this.selectList[item.prop].length
      );
      if (item.prop == "questionSource") {
        if (this.selectList[item.prop].length < item.List.length) {
          let list = [];
          item.List.map((subItem) => {
            list.push(subItem.value);
          });
          list.unshift("全部");
          console.log("踢除全部======>", list);
          this.selectList[item.prop] = list;
        } else {
          this.selectList[item.prop] = [];
        }
      }

      this.$emit("selectAll", item);
    },

    getSearchVal() {
      let contentIndexIds = [];
      let departIds = [];
      if (this.selectList?.contentIndexIds?.length > 0) {
        contentIndexIds = this.selectList?.contentIndexIds?.map(
          (item) => item[item.length - 1]
        );
      }
      if (this.selectList?.departmentName?.length > 0) {
        departIds = this.selectList?.departmentName?.map(
          (item) => item[item.length - 1]
        );
      }
      // console.log(this.selectList, 'kkkkkkkkakakkakak====----------------->');

      let searchValues = {
        drugID: this.selectList.drugID,
        editorialDoctor: this.selectList.editorialDoctor, // 编审医生
        queryItem: this.selectList.queryItem || null, // 疾病ID
        selectDiseaseInfoId1: this.selectList.selectDiseaseInfoId1, // 疾病名称
        selectDiseaseInfoId:
          this.selectList.selectDiseaseInfoId &&
          this.selectList.selectDiseaseInfoId.length
            ? this.selectList.selectDiseaseInfoId[0]
            : [], // 疾病名称
        selectedDeparttId:
          this.selectList.selectDiseaseInfoId &&
          this.selectList.selectDiseaseInfoId.length
            ? this.selectList.selectedDeparttId[1]
            : null, // 科室信息
        contentStatus: this.contentStatus || null, // 文章状态
        articleId: this.selectList.articleId || null, //文章ID
        articleKeyWord: this.selectList.articleKeyWord || null, // 文章关键字
        diseaseLabel: this.selectList.diseaseLabel || null, // 疾病标签
        nickname: this.selectList.nickname || null, // 写手昵称
        writerPin: this.selectList.writerPin || null, // 写手Pin
        doctorName: this.selectList.doctorName || null, // 医生名字
        hospital: this.selectList.hospital || null, // 医院名称
        department: this.selectList.department || null, // 科室名称
        articleType: this.selectList.articleType || null, // 文章类型
        submissionTime: this.selectList.submissionTime || [], // 投稿时间
        auditTime: this.selectList.auditTime || [], // 审核时间
        range: this.selectList.range || [],
        quality: this.selectList.quality || [],
        featuredArticle: this.selectList.featuredArticle || null, // 精选文章
        isOriginal: this.selectList.isOriginal || null, // 是否原创
        bindTask: this.selectList.bindTask || 1, // 是否绑定内容
        isTop: this.selectList.isTop || null, // 是否置顶
        businessIds: this.selectList.business || null,
        categoryId: this.selectList.categoryId || null,
        channelId: this.selectList.channelId || null,
        articleLabel: this.selectList.articleLabel || null, // 内容标签
        publishStatus: this.selectList.publishStatus || null, // 问答 公开状态
        contentIndexIds,
        contentDiseasesNotNull: this.selectList.contentDiseasesNotNull || null,
        sortOrderParams: this.sortOrderParams,
      };

      console.log("searchValues --------->", searchValues);
      //
      this.$emit("getChangeValue", searchValues);
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.getOriginalAuthorsByName(query);
      } else {
        this.options = [];
      }
    },
    remoteMethods(query) {
      console.log("输入的搜索框");
      console.log(query);
      if (query !== "") {
        this.loading = true;
        // this.form.contentName = query
        this.searchDiseaseInfoByParam(query);
      } else {
        this.options = [];
      }
    },
    getOriginalAuthorsByName(query) {
      listDiseaseInfoByName({
        tenantId: this.$commonJs.getTenantId(),
        diseaseName: query,
      })
        .then((res) => {
          console.log("🚀 ~ getOriginalAuthorsByName ~ res =====!!!!:", res);
          let arr = res.map((item) => {
            return {
              value: item.diseaseId,
              label: item.diseaseName,
            };
          });
          this.select.map((item) => {
            if (item.prop == "diseaseLabel" && item.cfgID == 5000) {
              // console.log('来这了=====...........',item);
              item.List = arr;
            }
          });
          // if (this.select[2].prop == "diseaseLabel") {
          //   this.select[2].List = arr
          // }
          this.options = res;
          this.loading = false;
          this.query = "";
        })
        .catch((err) => {
          this.options = [];
          this.loading = false;
          this.query = "";
        });
    },
    pageCategoriesByBusinessId(businessId) {
      this.selectList.categoryId = "";
      this.selectList.channelId = "";
      // 内容审核栏目
      // if (this.select[14]) {
      //   if (this.select[14].prop == "categoryId") {
      //     this.select[14].List = [];
      //   }
      // }
      this.select.map((item) => {
        if (item.prop == "categoryId" && item.cfgID == 4000) {
          item.List = [];
        }
      });
      // 分发市场栏目
      if (this.select[12]) {
        if (this.select[12].prop == "categoryId") {
          this.select[12].List = [];
        }
      }
      // if (this.select[10]) {
      //   this.select[10].List = [];
      // }
      // 内容审核频道
      // if (this.select[15]) {
      //   if (this.select[15].prop == "channelId") {
      //     this.select[15].List = [];
      //   }
      // }
      this.select.map((item) => {
        if (item.prop == "channelId" && item.cfgID == 4000) {
          item.List = [];
        }
      });
      // 问答库栏目
      if (this.select[7]) {
        if (this.select[7].prop == "categoryId") {
          this.select[7].List = [];
        }
      }
      let request =
        businessId.length > 1
          ? pageCategoriesByBusinessIds
          : pageCategoriesByBusinessId;
      let params = {
        tenantId: this.$commonJs.getTenantId(),
        ...this.pageConfig,
      };
      if (businessId.length > 1) {
        params.contentBusinessIds = businessId;
      } else {
        params.contentBusinessId = `${businessId}`;
      }
      if (businessId != "") {
        request(params).then((res) => {
          let arr = res.data.map((item) => {
            return {
              value: item.id,
              label: item.name,
            };
          });
          res.data.forEach((item) => {
            // 内容审核栏目
            // if (this.select[14]) {
            //   if (this.select[14].prop == "categoryId") {
            //     this.select[14].List.push({
            //       label: item.name,
            //       value: item.id
            //     })
            //   }
            // }
            // eslint-disable-next-line vue/no-mutating-props
            this.select = this.select.map((subItem) => {
              if (subItem.prop == "categoryId" && subItem.cfgID == 4000) {
                subItem.List.push({
                  label: item.name,
                  value: item.id,
                });
              }
              return subItem;
            });
            // 分发市场栏目
            if (this.select[12]) {
              if (this.select[12].prop == "categoryId") {
                this.select[12].List.push({
                  label: item.name,
                  value: item.id,
                });
              }
            }
            // 问答库栏目
            if (this.select[7]) {
              if (this.select[7].prop == "categoryId") {
                this.select[7].List.push({
                  label: item.name,
                  value: item.id,
                });
              }
            }
          });
        });
      }
    },
    pageChannelsByCategoryId(categoryId) {
      this.selectList.channelId = "";
      this.selectList.channelId = [];
      // 内容审核频道
      // if (this.select[15]) {
      //   if (this.select[15].prop == "channelId") {
      //     this.select[15].List = [];
      //   }
      // }
      this.select.map((item) => {
        if (item.prop == "channelId" && item.cfgID == 4000) {
          item.List = [];
        }
      });

      // 分发市场频道
      if (this.select[13]) {
        if (this.select[13].prop == "channelId") {
          this.select[13].List = [];
        }
      }
      // 问答库频道
      if (this.select[8]) {
        if (this.select[8].prop == "channelId") {
          this.select[8].List = [];
        }
      }
      let request =
        categoryId.length > 1
          ? pageChannelsByCategoryIds
          : pageChannelsByCategoryId;
      let params = {
        tenantId: this.$commonJs.getTenantId(),
        ...this.pageConfig,
      };
      if (categoryId.length > 1) {
        params.contentCategoryIds = categoryId;
      } else {
        params.contentCategoryId = `${categoryId}`;
      }
      if (categoryId != "") {
        request(params).then((res) => {
          let arr = res.data.map((item) => {
            return {
              value: item.id,
              label: item.name,
            };
          });
          // 内容审核频道
          res.data.forEach((item) => {
            // if (this.select[15]) {
            //   if (this.select[15].prop == "channelId") {
            //     this.select[15].List.push({
            //       label: item.name,
            //       value: item.id
            //     })
            //   }
            // }
            // eslint-disable-next-line vue/no-mutating-props
            this.select = this.select.map((subItem) => {
              if (subItem.prop == "channelId" && subItem.cfgID == 4000) {
                // console.log('来这了----->','======>',subItem,item);
                subItem.List.push({
                  label: item.name,
                  value: item.id,
                });
              }
              return subItem;
            });
            // 分发市场频道
            if (this.select[13]) {
              if (this.select[13].prop == "channelId") {
                this.select[13].List.push({
                  label: item.name,
                  value: item.id,
                });
              }
            }
            // 问答库频道
            if (this.select[8]) {
              if (this.select[8].prop == "channelId") {
                this.select[8].List.push({
                  label: item.name,
                  value: item.id,
                });
              }
            }
          });
        });
      }
    },
    queryChildAttributeByPid(parentId) {
      this.selectList.level = "";
      // 分发级别
      if (this.select[15]) {
        if (this.select[15].prop == "level") {
          this.select[15].List = [];
        }
      }
      if (parentId == 18) {
        queryParentAttributeByTyp({
          // parentId: 18
          attributeType: 25,
        }).then((res) => {
          res.map((item) => {
            if (this.select[15]) {
              if (this.select[15].prop == "level") {
                this.select[15].List.push({
                  label: item.desc,
                  value: item.id,
                });
              }
            }
          });
          this.select[15].levelList = res;
        });
      }
    },
  },
  components: {
    searchFilter,
    rangeSelection,
  },
};
</script>

<style lang="scss" scoped>
.boxs {
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 10px;

  .bottom {
    margin-top: 14px;

    .but {
      float: right;
      margin-left: 10px;
      padding-top: 10px !important;
    }
  }
}

:deep(.el-select) {
  width: 100%;
}

:deep(.el-date-editor) {
  width: 100%;
}

:deep(.el-time-panel .el-popper) {
  margin: 4px -23px !important;
}

// :deep(.but) {
//   padding-top: 10px !important;
// }

:deep(.el-cascader) {
  width: 100%;
}

:deep(.el-range-separator) {
  width: 20px !important;
}
</style>
